import React, { Component } from 'react'
import classname from 'classnames';
import ReactTooltip from 'react-tooltip'
import '../../App.css';
import { connect } from 'react-redux';
import { ToggleQuestion } from '../../actions/FAQ.js';

class FAQ_Component extends Component {
  constructor(props) {
    super(props)
    this.state = {
      faq: [
        {
          question: 'Does EditMyPaper provide basic proofreading or comprehensive editing?',
          answer: 'At EditMyPaper, we offer comprehensive editing services that will help improve your paper in all aspects. Our services include fixing your text\'s grammar, spelling, and punctuation errors, as well as checking for terminology and language use. We also offer conciseness editing to reduce wordiness without changing the meaning or effect of your paper. In addition, we offer substantive feedback on topic development and formatting to conform with applicable style guides. The service level you choose will affect the depth of editing and the education/experience the editor has working with documents similar to yours.',
          active: false
        },
        {
          question: 'What type of customer service or support do you offer?',
          answer: 'We provide prompt customer service for any inquiry via live chat or <a href="mailto:info@editmypaper.ca">email</a>. This allows us to respond to many inquiries fast and only by actual editors who can review and discuss your question or requirements. We don\'t outsource our customer service, so you\'ll always get one of our friendly EMP Team members when emailing or chatting with us. We\'re friendly and want to ensure you\'re 100% satisfied, which is why we offer our 100% Guarantee – we’ll work with you until you are completely satisfied. Get started by continuing to upload your paper and choose from the options listed.',
          active: false
        },
        {
          question: 'Can I submit my university application essay, thesis, dissertation or journal manuscript?',
          answer: 'Yes, all documents can be submitted for editing and each document is assigned to the most appropriate editor. If you have a thesis, dissertation, or professional journal that you need edited by one of our PhD editors, choose our Gold or Pro level in Step 3 or contact us via Live Chat or via email at <a href="mailto:info@editmypaper.ca">info@editmypaper.ca</a> so we can provide you with a custom editing solution.',
          active: false
        },
        {
          question: 'What will you edit and correct?',
          answer: 'Your editor will improve your paper by editing and correcting your spelling, grammar, word choice, punctuation, flow, consistency, run-on sentences, sentence fragments, and punctuation. Editors will also provide comments to guide you through any necessary improvements.',
          active: false
        },
        {
          question: 'Can you edit my essay FAST? Can you edit it within 3 hours? If I submit it late at night or early morning, can I get it back by the morning?',
          answer: 'Simply put, YES, YES, and YES! We offer editing in as few as 1.5 hours! We also offer 3 hour service. Once you are logged in, you can upload your essay and choose how much time you want to wait for your paper to be edited – if the option is available, you WILL get your paper back in that amount of time.',
          active: false
        },
        {
          question: 'English is not my first language and I think my paper may need a LOT of editing. Can you help?',
          answer: 'Yes, we can! We\'re experts at understanding and editing ESL writing. Our editors consistently demonstrate their ability to edit and correct all levels of papers! You should select the ESL/Extra Editing additional service so your editor is able to fully correct all possible writing mistakes.',
          active: false
        },
        {
          question: 'Can you edit my essay FAST? Can you edit it within 1.5 or 3 hours? If I submit it late at night, can I get it back by the morning?',
          answer: "If the option you want is available, then you will receive your paper back within the time you’ve selected. We offer editing in as few as 90 minutes (for papers 1300 words or less)! We also offer a 3-hour service (for papers up to 2275 words) and longer options to save you money. You can submit your paper at any time, 24 hours a day, 7 days a week and you'll get your paper back in the amount of time you choose (turnaround time) if the option you want is available.",
          active: false
        },
        {
          question: 'Do you have admissions essay or application essay editors available?',
          answer: "Yes, we have specific editors who are approved to edit admissions documents including application essays, statements of purpose, and application writing samples. These editors know what it takes to get accepted (because they've all been through university and most have a Ph.D.). We always ensure the paper you submit, regardless of topic or quality, gets to the right editor and is returned on time, every time! Most of all, our services are confidential and hassle-free, meaning you can relax knowing you're getting the best possible service, and it will never be disclosed we assisted you!",
          active: false
        },
        {
          question: 'Are science, biology, or research editors available to revise technical writing?',
          answer: 'Yes, at EditMyPaper we have a wide variety of editors available for all disciplines and research areas. There are also specific editors who are experts at tackling pre-publication journal articles, as well as citation and formatting experts. Our editors include current and retired university professors, Ph.D. professional editors, and researchers.',
          active: false
        },
        {
          question: 'What if I want you to critique my paper and comment on it, not just edit it and make it read perfectly?',
          answer: 'We can do that! We offer additional options for a nominal fee including critiques, extra comments, formatting, and extra editing/ESL service. You can choose these options once you are on Step 3 while uploading your document.',
          active: false
        },
        {
          question: "What's Edit My Paper's story?",
          answer: "We have a team of over 500 editors who have attended various <b>top 10</b> universities in the US, UK, Canada, and Australia who are fully vetted and qualified to not only proofread, but edit your paper completely. Edit My Paper was started by a group of university graduates and has grown steadily over the past ten years. It's become popular with high school, college and university students, as well as professionals who need an accurate editor to correct their papers and improve their writing. Our editors are actual <b><i>people</i></b> who are on-call 24/7 and genuinely <b><i>enjoy</i></b> reading, correcting, and improving writing!",
          active: false
        }
      ]
    }
  }
  ToggleQuestion(i){
    console.log("open question ", i);
    this.props.dispatch(ToggleQuestion(i, this.props.FAQ.array));
  }
  toggleFaq(i, e) {
    console.log("Inside answer visible");
    var faq = this.state.faq
    faq[i].active = ! faq[i].active
    this.setState({
      faq: faq
    })
  }
  render() {
    console.log("inside faq render" );
    var faqs = this.state.faq.map((faq, i) => {
                console.log("Inside the rendered faqs each one ----->----->----->")
                console.log(this.props.FAQ)
                console.log(faq);
               console.log("Inside the rendered faqs each one ----->----->----->")
      var answerVisible = classname({
        'popup': true,
        'faq-closed': this.props.FAQ.array.indexOf(i) < - 1,
        'faq-active': this.props.FAQ.array.indexOf(i) > - 1
      })
      return(
        <div className="qa">
          <h3 className="faq-question" onClick={this.ToggleQuestion.bind(this, i)}>{faq.question}</h3>
            <div className={answerVisible} dangerouslySetInnerHTML={{__html: faq.answer}}>
            </div>
        </div>
      )
    })
    return(
      <div className="faq">
        {faqs}
      </div>
    )
  }
}
export default connect(
  ({Paper, FAQ})=>({Paper, FAQ})
)(FAQ_Component);

// className="popup-wrap"
//  className="popup-body faq-answer"
//<p className={answerVisible}>{faq.answer}</p>
// <div className="popup-header">
//       <div className="close-popup" onClick={this.toggleFaq.bind(this, i)}><i className="fa fa-times" aria-hidden="true"></i></div>
// </div>



// WEBPACK FOOTER //
// ./src/components/steps/FAQ.js